import PropTypes from "prop-types";
import ReactApexChart from "react-apexcharts";
// @mui
import { Card, CardHeader, Box } from "@mui/material";
// components
import { useChart } from "../../../components/chart";

// ----------------------------------------------------------------------

AppWebsiteVisits.propTypes = {
	title: PropTypes.string,
	subheader: PropTypes.string,
	chartData: PropTypes.array.isRequired,
	chartLabels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default function AppWebsiteVisits({ title, subheader, chartLabels, chartData, ...other }) {
	const chartOptions = useChart({
		chart: {
			type: "bar",
			toolbar: { show: false },
		},
		plotOptions: {
			bar: {
				columnWidth: "45%",
				borderRadius: 4,
				distributed: true,
			},
		},
		dataLabels: {
			enabled: true,
			offsetY: -20,
			style: {
				fontSize: "12px",
				colors: ["#304758"],
			},
			background: {
				enabled: true,
				foreColor: "#fff",
				padding: 4,
				borderRadius: 2,
				borderWidth: 1,
				borderColor: "#fff",
				opacity: 0.9,
				dropShadow: {
					enabled: true,
					top: 1,
					left: 1,
					blur: 1,
					color: "#000",
					opacity: 0.25,
				},
			},
			formatter: function (val) {
				return `${val} visits`;
			},
		},
		colors: [
			"#33b2df",
			"#546E7A",
			"#d4526e",
			"#13d8aa",
			"#A5978B",
			"#2b908f",
			"#f9a3a4",
			"#90ee7e",
			"#f48024",
			"#69d2e7",
		],
		xaxis: {
			type: "category",
			categories: chartLabels,
			labels: {
				style: {
					fontSize: "13px",
				},
			},
		},
		tooltip: {
			shared: true,
			intersect: false,
			y: {
				formatter: (y) =>
					typeof y !== "undefined" ? `${y.toFixed(0)} visits` : y,
			},
		},
	});




	return (
		<Card {...other}>
			<CardHeader title={title} subheader={subheader} />

			<Box sx={{ p: 3, pb: 1 }} dir="ltr">
				<ReactApexChart
					type="bar"
					series={chartData}
					options={chartOptions}
					height={364}
				/>
			</Box>
		</Card>
	);
}
